import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["guests", "addBtn", "guestTemplate"]
  static values = { count: { type: Number, default: 0 } }

  add() {
    const index = this.countValue
    const label = index + 2  // Guest 1 is primary, additional guests start at 2
    const html = this.guestTemplateTarget.innerHTML
      .replace(/__INDEX__/g, index)
      .replace(/__INDEX_LABEL__/g, label)
    this.guestsTarget.insertAdjacentHTML("beforeend", html)
    this.countValue = index + 1
    this.addBtnTarget.textContent = this.countValue >= 3 ? "Max 4 guests total" : "+ Add another guest"
    if (this.countValue >= 3) this.addBtnTarget.disabled = true
  }

  remove(event) {
    event.currentTarget.closest("[data-group-guest]").remove()
    this.countValue = Math.max(0, this.countValue - 1)
    this.addBtnTarget.disabled = false
    this.addBtnTarget.textContent = "+ Add another guest"
  }
}
